// extracted by mini-css-extract-plugin
export var testimonialQuote = "Testimonial-module--testimonialQuote--d8bdc";
export var testimonialSource = "Testimonial-module--testimonialSource--db8e1";
export var testimonialTextContent = "Testimonial-module--testimonialTextContent--14425";